import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import Rating from '@material-ui/lab/Rating';
import Box from '@material-ui/core/Box';


const styles = () => ({
    TextField: {
      maxWidth: '536px',
    },
    rating: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: 55,
    },
    starIcons: {
      fontSize: '2.5rem',
      color: '#ffc200'
    },
    emptyStar: {
      color: '#c1c1c1'
    },
    modalIcon: {
      fontSize: 32,
      padding: '0 8px'
    },
    cardIcon: {
      padding: '0 4px'
    },
    buttonsContainer: {
      display: 'flex',
      flexFlow: 'column',
      paddingTop: 40,
    },
    notNow: {
      background: 'unset',
      border: 0,
      fontSize: 14,
      fontWeight: 'bold',
      color: '#10587f',
      cursor: 'pointer',
      outline: 'unset'
    }
  });

  const labels = {
    0.5: 'Muy malo',
    1: 'Muy malo+',
    1.5: 'Malo',
    2: 'Malo+',
    2.5: 'Bien',
    3: 'Bien+',
    3.5: 'Bueno',
    4: 'Bueno+',
    4.5: 'Excelente',
    5: 'Excelente+',
  };


const OpinionForm = (props) => {
    const {
      values,
      handleChange,
      handleBlur,
      handleSubmit,
      touched,
      errors,
      isValid,
      isLawyer,
      classes,
      setFieldValue,
      setError,
    } = props;

    const [value, setValue] = useState(0.5);
    const [hover, setHover] = useState(-1);

    return ( 
      <>
        <div className={classes.rating}>
          <Rating
            name="hover-feedback"
            id={'rating'}
            defaultValue={0.5}
            value={value}
            precision={0.5}
            size="large"
            classes={{ iconEmpty: classes.emptyStar, icon: classes.modalIcon }}
            onChange={(event, newValue) => {
              setValue(newValue);
              if(newValue === null || newValue === NaN){
                setFieldValue('rating', 0)
              }else{setFieldValue('rating', newValue)}

              
            }}
            onChangeActive={(event, newHover) => {
              setHover(newHover);
            }}
          />
          {value !== null && <Box ml={2}>{labels[hover !== -1 ? hover : value]}</Box>}
        </div>

        <TextField
          label='Escribe tu opinión'
          id="opinion"
          type="text"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.opinion}
          helperText={touched.opinion && errors.opinion ? errors.opinion : ''}
          error={touched.opinion && errors.opinion ? true : false}
          fullWidth
          classes={{ root: classes.TextField }}
        />
        <ButtonBase
          type="submit"
          onClick={handleSubmit}
          variant="primary"
          disabled={!isValid}
        >
          Enviar
        </ButtonBase>
      </>
     );
}



export default withStyles(styles)(OpinionForm);